// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".notifies a,.notifies a:hover{color:#1c2127;text-decoration:none}.notifies .sign{font-style:italic;color:rgba(1,1,1,.5)}.notifies .col1{width:10%}.notifies .read{transition:background-color 500ms linear}.notifies .notread{background-color:#ddddf5}", ""]);
// Exports
module.exports = exports;
